/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('jquery-ui');

window.Vue = require('vue');
const axios = require('axios');
const dayjs = require('dayjs');
const th = require('dayjs/locale/th');
const relativeTime = require('dayjs/plugin/relativeTime');
const parseFormat = require('dayjs/plugin/customParseFormat');
const utcPlugin = require('dayjs/plugin/utc');
const currency = require('currency.js');
const big = require('big.js');

const api = require('./api')

dayjs.extend(relativeTime)
dayjs.extend(parseFormat)
dayjs.extend(utcPlugin)
dayjs.locale(th)

import VCalendar from '@pixelart7/v-calendar';

Vue.use(VCalendar, {

});
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

// Vue.component('example-component', require('./components/ExampleComponent.vue'));
// console.log("Register!");
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
Vue.component('stack-modal', require('@innologica/vue-stackable-modal').default);

Vue.component('register-component', require('./components/RegisterComponent.vue').default);
Vue.component('forgot-password-component', require('./components/ForgotPasswordComponent.vue').default);
Vue.component('list-new-member-component', require('./components/admin/ListNewMemberComponent.vue').default);
Vue.component('list-member-component', require('./components/admin/ListMemberComponent.vue').default);
Vue.component('list-member-v2-component', require('./components/admin/ListMemberV2Component.vue').default);
Vue.component('list-renew-member-component', require('./components/admin/ListRenewMemberComponent.vue').default);
Vue.component('list-deposit-component', require('./components/admin/ListDepositComponent.vue').default);
Vue.component('print-deposit-component', require('./components/admin/PrintDepositComponent.vue').default);
Vue.component('list-withdraw-component', require('./components/admin/ListWithdrawComponent.vue').default);
Vue.component('print-withdraw-component', require('./components/admin/PrintWithdrawComponent.vue').default);
Vue.component('list-contract-loan-component', require('./components/admin/contract/ListLoanComponent.vue').default);
Vue.component('list-contract-trade-component', require('./components/admin/contract/ListTradeComponent.vue').default);
Vue.component('list-contract-mortgage-component', require('./components/admin/contract/ListMortgageComponent.vue').default);
Vue.component('list-movement-component', require('./components/admin/movement/ListComponent.vue').default);
Vue.component('goobanklist-movement-component', require('./components/admin/movement/GoobankListComponent.vue').default);
Vue.component('customerlist-movement-component', require('./components/admin/movement/CustomerListComponent.vue').default);
Vue.component('print-movement-component', require('./components/admin/movement/PrintComponent.vue').default);
Vue.component('setting-component', require('./components/admin/SettingComponent.vue').default);
Vue.component('setting-background-picture-component', require('./components/admin/SettingBackgroundPictureComponent.vue').default);
Vue.component('member-change-avatar', require('./components/pages/member/ChangeAvatar.vue').default)
Vue.component('member-change-password', require('./components/pages/member/ChangePassword.vue').default)

Vue.component('otp-block-input', require('./components/sub_components/OTPBlockInput.vue').default);

Vue.component('error-cant-reach-server', require('./components/sub_components/common_errors/CantReachServer.vue').default);
Vue.component('error-cant-reach-server-small', require('./components/sub_components/common_errors/CantReachServerSmall.vue').default);
Vue.component('error-not-enough-money', require('./components/sub_components/common_errors/NotEnoughMoney.vue').default);
Vue.component('error-not-enough-data', require('./components/sub_components/common_errors/NotEnoughData.vue').default);
Vue.component('error-not-enough-money-for-credit', require('./components/sub_components/common_errors/NotEnoughMoneyForCredit.vue').default);

window.BASE_URL = `${location.origin}/`

Vue.filter('money', function(value) {
    if (typeof value === 'object') value = value.toString()
    if (value !== 0 && !value) return ''
    return currency(value).format()
})

Vue.use({
    install(V, options) {
        V.prototype.$baseUrl = window.BASE_URL
        V.prototype.$axios = axios
        V.prototype.$dayjs = dayjs
        V.prototype.$big = big
        V.prototype.$currency = currency
        V.prototype.$api = api.default
        V.prototype.$util = {
            url(path) {
                const url = new URL(path, window.BASE_URL)
                return url.href
            },
            asset(path) {
                const url = new URL(path, window.BASE_URL)
                return url.href
            }
        }
        V.prototype.$reloadPage = () => {
            location.reload()
        }
        V.prototype.$contractStatusDict = {
            wait_for_approve: 'รออนุมัติ',
            active: 'ปกติ',
            rejected: 'ไม่อนุมัติ',
            canceled: 'ปิดสัญญา',
            disputed: 'รอแก้เอกสาร',
            postponed: 'ผ่อนผันแล้วในรอบนี้',
            ended: 'ปิดสัญญา'
        }
    }
})

if ($('#app').length) // for normal mounting
{
    const app = new Vue({
        el: '#app'
    });
}

// Load Vue-handled modules
require('./module-deposit')
require('./module-withdraw')
require('./module-new-contract')
require('./module-activity')
require('./module-transaction-contract')
require('./module-pay')
require('./module-transaction')
require('./module-credit-bureau')
require('./module-setting-docs')
